import { SET_GEOFENCE_DATA, SET_TOTAL_GEOFENCES, SET_GEOFENCE_CURRENT_PAGE, SET_GEOFENCE_PAGE_SIZE, REMOVE_GEOFENCES } from "../types"

const initialState = {
  geofences: [],
  totalItems: 0,
  page: 1,
  pageSize: 10,
}

const geofenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GEOFENCE_DATA:
      return {
        ...state,
        geofences: action.payload,
      }
    case SET_TOTAL_GEOFENCES:
      return {
        ...state,
        totalItems: action.payload,
      }
    case SET_GEOFENCE_CURRENT_PAGE:
      return {
        ...state,
        page: action.payload,
      }
    case SET_GEOFENCE_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload,
      }
    case REMOVE_GEOFENCES:
      return {
        ...initialState
      }
    default:
      return state
  }
}

export default geofenceReducer